export default __webpack_public_path__ + "static/media/SeñorEquilibristaD.eabb77c5.png";